/**
 * 从「文字 + 链接」混合内容中提取地图 URL
 * 例：
 *   城东四路220号
 *   中国, 浙江省, 丽水市, 龙泉市
 *   https://surl.amap.com/DWrMdg1p0Cs
 */

const MAP_HOST_HINT = /(?:amap\.com|gaode\.com|baidu\.com|map\.qq\.com|qq\.com\/map|google\.com\/maps|maps\.google\.com|goo\.gl\/maps|ovital\.com|j\.map\.baidu\.com|surl\.amap\.com|uri\.amap\.com|dwz\.cn)/i;

/**
 * @param {string} text
 * @returns {string|null} 提取到的 http(s) 地图链接；没有则 null
 */
export function extractMapUrlFromText(text) {
  if (!text || typeof text !== 'string') return null;
  const raw = text.trim();
  if (!raw) return null;

  // 整段本身就是链接
  if (/^https?:\/\/\S+$/i.test(raw)) {
    return raw.replace(/[)\]}>.,;，。；]+$/g, '');
  }

  // 找出所有 http(s) URL（允许换行前后夹杂中文地址）
  const urlRe = /https?:\/\/[^\s<>"'，。；、]+/gi;
  const candidates = [];
  let m;
  while ((m = urlRe.exec(raw)) !== null) {
    const cleaned = m[0].replace(/[)\]}>.,;，。；]+$/g, '');
    if (cleaned) candidates.push(cleaned);
  }
  if (candidates.length === 0) return null;

  // 优先地图域名；否则取第一个 http 链接
  const preferred = candidates.find((u) => MAP_HOST_HINT.test(u));
  return preferred || candidates[0];
}

export default extractMapUrlFromText;
